/**
 * Enumerated categories for payment errors.
 * Used for error handling logic and recovery attempts.
 */
export const PaymentErrorCategories = {
  /**
   * Misconfiguration on venue; Implausible code path
   */
  CONFIGURATION: "configuration",
  /**
   * Third-party payment processor SDK failed to load; Unhandled race conditions
   */
  INITIALIZATION: "initialization",
  /**
   * Issues during an attempt to process (confirm) a purchase
   */
  PROCESSING: "processing",
  /**
   * Issues directly stemming from a payment confirmation
   */
  CONFIRMATION: "confirmation",
  /**
   * TODO drop as its too similar to CONFIGURATION
   */
  SYSTEM: "system",
} as const;

export type PaymentErrorCategory =
  (typeof PaymentErrorCategories)[keyof typeof PaymentErrorCategories];
